// extracted by mini-css-extract-plugin
export default {"error":"styles__error___pstmF"};